module.exports = __webpack_public_path__ + "img/kiwi-lotus-only.6f65a128.png";